import script from "./KnowMore.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowMore.vue?vue&type=script&setup=true&lang=js"

import "./KnowMore.vue?vue&type=style&index=0&id=5654975e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5654975e"]])

export default __exports__